const DEFAULT_TZ = 'America/New_York';

function getUserTz(user) {
  return user?.timezone || DEFAULT_TZ;
}

export function formatExpiry(isoString, user) {
  if (!isoString) return '—';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: getUserTz(user),
  });
}

export function formatExpiryWithTime(isoString, user) {
  if (!isoString) return '—';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: getUserTz(user),
  });
}

/**
 * Format an elapsed millisecond span as a short relative label ('45s', '3min').
 *
 * Mirrors the unit thresholds in the backend's format_relative_time() so the
 * React dashboard and the legacy template read identically.
 */
export function formatElapsed(ms) {
  const seconds = Math.floor(ms / 1000);
  // Clamp: a receiver clock marginally ahead of the browser's would otherwise
  // render a negative span.
  if (seconds < 60) return `${Math.max(seconds, 0)}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}min`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
  if (seconds < 2592000) return `${Math.floor(seconds / 86400)}d`;
  return `${Math.floor(seconds / 2592000)}mo`;
}

export function daysUntil(isoString) {
  if (!isoString) return null;
  const diff = new Date(isoString) - new Date();
  return Math.ceil(diff / 86400000);
}

export function hoursUntil(isoString) {
  if (!isoString) return null;
  const diff = new Date(isoString) - new Date();
  return Math.ceil(diff / 3600000);
}
